import LOGO from "../images/Omega.png";

export const Team__Omega = {
  name: "Omega",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#7C3AED",
  teamJerseyColor: "#DC2626",

  // Stats
  gamesWon: 3,
  gamesLost: 1,
  gamesTied: 0,
  gamesTiedWon: 0,

  // ownGoalsInFavor: 0 + 24 + 40 + 40,
  // goalsScoredAgainst: 20 + 21 + 15 + 16,
  ownGoalsInFavor: 0 + 24,
  goalsScoredAgainst: 20 + 21,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [],
};
